import React from 'react';
import LegalLayout, { LegalSection } from '../components/layout/LegalLayout';

export default function RefundPolicyPage() {
  return (
    <LegalLayout title="Politique de Remboursement" lastUpdated="Janvier 2025">
      <p className="italic text-linx_text-muted">
        La présente politique précise dans quels cas LinxExpress peut traiter des ajustements de commission et fixe strictement les limites de remboursement.
      </p>

      <LegalSection title="Champ d'Application">
        <p>Cette politique s'applique uniquement aux montants liés à la plateforme payés par les chauffeurs à LinxExpress (recharge wallet/solde de commission). Elle ne s'applique pas au prix du transport payé directement entre client et transporteur.</p>
      </LegalSection>

      <LegalSection title="Cas Éligibles à un Ajustement de Commission">
        <p>Un ajustement de commission peut être examiné lorsqu'une annulation/un litige est justifié selon les règles in-app :</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-2">
          <li>Client absent ou faute client vérifiée</li>
          <li>Motif d'annulation vérifié et validé par la revue plateforme</li>
          <li>Erreur système ou de traitement impactant la déduction de commission</li>
        </ul>
      </LegalSection>

      <LegalSection title="Cas Non Éligibles">
        <p>Aucun ajustement n'est accordé pour les demandes abusives, frauduleuses ou non justifiées :</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-2">
          <li>Absence de preuve valide lorsque la preuve est requise</li>
          <li>Transactions hors plateforme ou contournement des frais</li>
          <li>Usage de catégories interdites ou autre violation des Conditions</li>
        </ul>
      </LegalSection>

      <LegalSection title="Aucun Virement vers Banque Chauffeur">
        <p>En fonctionnement normal, LinxExpress n'effectue pas de remboursement par virement bancaire au chauffeur. Tout remboursement approuvé est traité uniquement sous forme d'ajustement interne de commission/solde wallet dans l'application chauffeur. Exception : en cas d'arrêt définitif du service, les soldes éligibles restants peuvent être remboursés via une procédure formelle de clôture.</p>
      </LegalSection>

      <LegalSection title="Examen et Délai">
        <p>Les demandes sont examinées au cas par cas. Les demandes doivent être soumises dans un délai de trente (30) jours suivant l'événement contesté. Délai cible de première revue : sept (7) jours ouvrables.</p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>Pour toute question relative aux remboursements : contact@agodevsolutions.com. Une demande d'escalade interne peut être soumise dans les dix (10) jours suivant la notification.</p>
      </LegalSection>
    </LegalLayout>
  );
}
